export default [
  {
    id: 'scene1',
    urls: [],
  },
]
